import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=2ca27ec6&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ca27ec6', component.options)
    } else {
      api.reload('2ca27ec6', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=2ca27ec6&", function () {
      api.rerender('2ca27ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/PrivacyPolicy.vue"
export default component.exports